import React from "react";

import BeforeVoting from "../components/BeforeVoting";
import AfterVoting from "../components/AfterVoting";

const Voting = ({
  users,
  photo,
  roomId,
  cc_vote,
  captions,
  playerObj,
  mobile_app,
  set_cc_vote,
  currentPlayer,
  voting_params,
}) => {
  return playerObj === undefined ? (
    <BeforeVoting
      photo={photo}
      roomId={roomId}
      cc_vote={cc_vote}
      captions={captions}
      mobile_app={mobile_app}
      set_cc_vote={set_cc_vote}
      currentPlayer={currentPlayer}
      voting_params={voting_params}
    />
  ) : (
    <AfterVoting users={users} photo={photo} captions={captions} playerObj={playerObj} voting_params={voting_params} />
  );
};

export default Voting;
